export default __webpack_public_path__ + "images/yellow-magnifying-glass.png";